const timeZones = [
  // USA
  { name: "USA (Eastern) - New York", value: "America/New_York" },
  { name: "USA (Central) - Chicago", value: "America/Chicago" },
  { name: "USA (Mountain) - Denver", value: "America/Denver" },
  { name: "USA (Pacific) - Los Angeles", value: "America/Los_Angeles" },
  { name: "USA (Alaska) - Anchorage", value: "America/Anchorage" },
  { name: "USA (Hawaii) - Honolulu", value: "Pacific/Honolulu" },

  // Canada
  { name: "Canada (Eastern) - Toronto", value: "America/Toronto" },
  { name: "Canada (Central) - Winnipeg", value: "America/Winnipeg" },
  { name: "Canada (Mountain) - Edmonton", value: "America/Edmonton" },
  { name: "Canada (Pacific) - Vancouver", value: "America/Vancouver" },

  // UK & Europe
  { name: "United Kingdom - London", value: "Europe/London" },
  { name: "Germany - Berlin", value: "Europe/Berlin" },
  { name: "France - Paris", value: "Europe/Paris" },
  { name: "Italy - Rome", value: "Europe/Rome" },
  { name: "Spain - Madrid", value: "Europe/Madrid" },
  { name: "Netherlands - Amsterdam", value: "Europe/Amsterdam" },
  { name: "Russia - Moscow", value: "Europe/Moscow" },

  // Asia
  { name: "India - Mumbai", value: "Asia/Kolkata" },
  {name:"India Standard Time",value:"Asia/Calcutta"},
  { name: "China - Beijing", value: "Asia/Shanghai" },
  { name: "Japan - Tokyo", value: "Asia/Tokyo" },
  { name: "South Korea - Seoul", value: "Asia/Seoul" },
  { name: "Singapore", value: "Asia/Singapore" },
  { name: "Pakistan - Karachi", value: "Asia/Karachi" },
  { name: "Bangladesh - Dhaka", value: "Asia/Dhaka" },
  { name: "Nepal - Kathmandu", value: "Asia/Kathmandu" },

  // Australia
  { name: "Australia (Eastern) - Sydney", value: "Australia/Sydney" },
  { name: "Australia (Central) - Adelaide", value: "Australia/Adelaide" },
  { name: "Australia (Western) - Perth", value: "Australia/Perth" },

  // Middle East
  { name: "UAE - Dubai", value: "Asia/Dubai" },
  { name: "Saudi Arabia - Riyadh", value: "Asia/Riyadh" },
  { name: "Israel - Jerusalem", value: "Asia/Jerusalem" },

  // Africa
  { name: "South Africa - Johannesburg", value: "Africa/Johannesburg" },
  { name: "Egypt - Cairo", value: "Africa/Cairo" },

  // South America
  { name: "Brazil - Sao Paulo", value: "America/Sao_Paulo" },
  { name: "Argentina - Buenos Aires", value: "America/Argentina/Buenos_Aires" }
];

export default timeZones;